import { render } from "./OrderTemplate.vue?vue&type=template&id=3ccd20d8"
import script from "./OrderTemplate.vue?vue&type=script&lang=js"
export * from "./OrderTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__